import React, { useEffect, useState, useCallback } from 'react';
import { api } from '../../api';
import { Spinner, Alert, Pagination, EmptyState } from '../../components/UI';

export default function AuditLog() {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    api.get(`/audit?page=${page}&limit=30`).then(setData).catch(e => setError(e.message));
  }, [page]);

  useEffect(() => { load(); }, [load]);

  if (!data && !error) return <Spinner />;
  const totalPages = data ? Math.max(1, Math.ceil(data.total / data.limit)) : 1;

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="eyebrow">Administration</div>
          <h1>Audit log</h1>
        </div>
      </div>

      <Alert type="danger">{error}</Alert>

      {data && data.logs.length === 0 && (
        <div className="card"><EmptyState title="No activity recorded yet" /></div>
      )}

      {data && data.logs.length > 0 && (
        <>
          <div className="table-wrap">
            <table>
              <thead><tr><th>When</th><th>User</th><th>Action</th><th>Entity</th><th>Details</th></tr></thead>
              <tbody>
                {data.logs.map(l => (
                  <tr key={l.id}>
                    <td className="text-sm text-muted">{new Date(l.created_at).toLocaleString('en-IN')}</td>
                    <td>{l.user_name || 'System'}</td>
                    <td className="mono text-sm">{l.action}</td>
                    <td className="text-sm text-muted">{l.entity}{l.entity_id ? ` #${l.entity_id}` : ''}</td>
                    <td className="text-sm mono" style={{ maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {l.details ? JSON.stringify(l.details) : '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </>
      )}
    </div>
  );
}
